import { UploadStatus } from "features/shared/model/types";

import type { CreateJobResponse, FileWithInfo, SingleBuildingFormState } from "../../model/types";

export type HandleSubmitBase = (params: {
  caller: SubmitCaller;
  dtCreation: boolean;
  shouldDeleteImages: boolean;
}) => void;

export type ModalActionButton = {
  label: string;
  onClick: () => void;
  show: boolean;
};

export type SubmitAction = {
  action: () => void;
  getNavigateUrl: (projectId: string) => string | undefined;
  projectActionLabel: string;
};

export type SubmitCaller = (
  formData: SingleBuildingFormState,
  dtCreation: boolean
) => Promise<CreateJobResponse | undefined>;

export type SubmitInfo = {
  buildingInfo: SubmitStepInfo;
  deletedAPIImages: SubmitStepInfo[];
  files: SubmitStepInfo[];
  images: SubmitStepInfo[];
  projectCreation: SubmitStepInfo;
};

export type SubmitInfoAction =
  | { base: SubmitInfo; formData: SingleBuildingFormState; type: "PREPARE_SUBMIT" }
  | {
      errorMessage?: string | undefined;
      file: FileWithInfo;
      list: "deletedAPIImages" | "files" | "images";
      percentage: number;
      status: SubmitStepInfo["status"];
      type: "UPSERT_UPLOAD_ROW";
    }
  | { formData: SingleBuildingFormState; type: "SYNC_FROM_FORM" }
  | { type: "MARK_IN_PROGRESS_UPLOADS_ERRORED" }
  | { type: "UPDATE_BUILDING_INFO"; updater: (prev: SubmitStepInfo) => SubmitStepInfo }
  | { type: "UPDATE_PROJECT"; updater: (prev: SubmitStepInfo) => SubmitStepInfo };

export type SubmitStepInfo = {
  errorMessage?: string | undefined;
  id?: string;
  name: string;
  percentage?: number;
  status: UploadStatus;
};

export const isNotStartedYet = (status: "completed" | "error" | "progress" | undefined) => status === undefined;
export const isErrored = (status: "completed" | "error" | "progress" | undefined) => status === "error";

export type UseSubmitInfoStateParams = {
  formData: SingleBuildingFormState;
  projectId: string | undefined;
};
